/**
 * トライアル介入リストのラベル（#1705 SS-07）。
 * i18n せず日本語直書き（admin-ops 内部 UI のため、`Workspaces/labels.ts` と同じ方針）。
 */
import type { TrialReason } from '../../lib/trials-api';

export const TRIAL_REASON_LABEL: Record<TrialReason, string> = {
  // 自動判定（docs/growth/self-serve-strategy.md §4）
  setup_incomplete: '設定が途中',
  no_lead: '見込み客が未登録',
  active_no_progress: 'ログインのみで進捗なし',
  pricing_interest: '料金ページを複数回閲覧',
  // Founder 手動フラグ（正本が「自動判定しない」としている 2 つ）
  high_fit: '高適合企業',
  inquiry: '問い合わせあり',
};

/** 手動で立てられるフラグと、ボタンに出す短いラベル。 */
export const TRIAL_FLAG_BUTTONS = [
  { key: 'high_fit', label: '高適合' },
  { key: 'inquiry', label: '問い合わせ' },
] as const;

/** 最短ガイドのステップ数（`@aic/db/trial-intervention` の QUICKSTART_TOTAL と揃える）。 */
export const QUICKSTART_TOTAL = 4;

/**
 * トライアル終了までの残り日数（切り上げ）。終了済みは 0、未設定は null。
 *
 * `apps/api/src/lib/trial.ts` の `trialDaysRemaining` と同じ意味。表示のための計算なので
 * API を跨いで共有せず、ここで持つ。
 */
export function trialDaysRemaining(
  trialEndsAtIso: string | null,
  now: Date = new Date(),
): number | null {
  if (!trialEndsAtIso) return null;
  const end = Date.parse(trialEndsAtIso);
  if (Number.isNaN(end)) return null;
  const ms = end - now.getTime();
  if (ms <= 0) return 0;
  return Math.ceil(ms / 86_400_000);
}
